// Shared configuration for audit full analysis batching
// Purpose: Single source of truth for token-based batching parameters

// Mini model (gpt-4.1-mini): 100K TPM limit from Azure
export const MINI_MAX_INPUT_TOKENS = 30000; // Safe per-batch token budget (60% safety margin)
export const EST_TOKENS_PER_ITEM = 600; // Fallback est. tokens per item when exact calc fails

// Premium model (gpt-5-premium, gpt-4.1-premium): 50K TPM limit from Azure
export const PREMIUM_MAX_INPUT_TOKENS = 30000; // Safe per-call budget (60% safety margin)
export const PREMIUM_EST_TOKENS_PER_BOOST = 600; // Estimated tokens per boost call
